import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Button } from './Button.styled'

const NavButton = ({
  onClickFunc,
  content,
  ariaLabel,
  isDisabled,
  isModalBtn,
  isStopAccessBtn,
  isFocused,
  isBtnFocused,
}) => {
  const funcButton = useRef(null)
  if (isBtnFocused) {
    funcButton.current.focus()
  }
  return (
    <Button
      onClick={onClickFunc}
      aria-label={ariaLabel}
      isModalBtn={isModalBtn}
      isStopAccessBtn={isStopAccessBtn}
      disabled={isDisabled === undefined ? false : isDisabled}
      autoFocus={isFocused}
      ref={funcButton}
    >
      {content}
    </Button>
  )
}

NavButton.propTypes = {
  onClickFunc: PropTypes.func,
  content: PropTypes.string,
  isDisabled: PropTypes.bool,
  isModalBtn: PropTypes.bool,
  isStopAccessBtn: PropTypes.bool,
  isFocused: PropTypes.bool,
}

export default NavButton
